import { render, staticRenderFns } from "./list-user.vue?vue&type=template&id=940088c0&"
import script from "./list-user.vue?vue&type=script&lang=js&"
export * from "./list-user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports